    // Registration.jsx
import React, { useState, useEffect } from 'react';
import {
  CognitoUserPool,
  CognitoUser,
  CognitoUserAttribute,
} from 'amazon-cognito-identity-js';
import {
  Container,
  TextField,
  Button,
  Box,
  Link,
  Typography,
} from '@mui/material';
import { styled } from '@mui/system';
import TypingLine from 'components/TypingLine';

// v2: el verde Matrix se retira — terminal en la paleta de marca (IDENTIDAD_VISUAL.md §9)
const StyledContainer = styled(Container)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  backgroundColor: 'transparent',
  color: '#C77DFF',
  fontFamily: 'monospace',
});

const StyledBox = styled(Box)({
  backgroundColor: '#14141F',
  padding: '2rem',
  width: 'min(600px, 92vw)',
  height: 'auto',
  color: '#EDE9F7',
  fontFamily: 'monospace',
  border: '1px solid rgba(237,233,247,0.08)',
  borderRadius: '10px',
  boxShadow: 'none',
});

const StyledTextField = styled(TextField)({
  '& input': {
    color: '#EDE9F7',
    fontFamily: 'monospace',
    backgroundColor: 'transparent',
    padding: '6px',
  },
  '& .MuiInputBase-root': {
    borderBottom: '1px solid rgba(199,125,255,.4)',
  },
  '& .MuiInput-underline:before, & .MuiInput-underline:after': {
    borderBottom: '1px solid rgba(199,125,255,.4)',
  },
  '& label': {
    color: '#A8A3B8',
  },
});

const StyledButton = styled(Button)({
  marginTop: '1rem',
  color: '#C77DFF',
  borderColor: 'rgba(199,125,255,.4)',
  fontFamily: 'monospace',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: 'rgba(157,0,255,.08)',
  },
});

const Registration = ({ onLogin, onLogout }) => {
  const userPool = new CognitoUserPool({
    UserPoolId: 'us-east-2_gCcm4sPzU',
    ClientId: '1k58piktqup5k1j852hau1nfqf',
  });

  const [stage, setStage] = useState(0);
  const [givenName, setGivenName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [registerSuccess, setRegisterSuccess] = useState(false);
  const [passErr, setPassErr] = useState('');

  const handleRegister = () => {
    setPassErr("");
    if (password !== password2) {
        setPassErr ("Los password no coinciden");
        return;
    }


    const attributeList = [
      new CognitoUserAttribute({ Name: 'nickname', Value: givenName.trim() }),
      new CognitoUserAttribute({ Name: 'email', Value: email.toLowerCase().trim() }),
    ];

    userPool.signUp(email, password.trim(), attributeList, null, (err, result) => {
      if (err) {
        console.error(err);
        if (!/[A-Z]/.test(password)) {
      setPassErr("Debe contener al menos una letra mayúscula.");
      }
      else if (!/[0-9]/.test(password)) {
      setPassErr("Debe contener al menos un numero.");
      }
      else if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
        setPassErr("Debe contener al menos un símbolo (como !, @, #, etc.).");
      }
      else if (password.length < 8) {
        setPassErr("Debe tener al menos 8 caracteres.");
      }
      else {
        setPassErr (err.message);
      }
        return; 
      }
      
      setRegisterSuccess(true);
      setStage(7);
    });
  };

  const handleVerification = () => {
    const userData = { Username: email, Pool: userPool };
    const cognitoUser = new CognitoUser(userData);
    setPassErr("");
    cognitoUser.confirmRegistration(verificationCode, true, (err, result) => {
      if (err) {
        console.error(err);
        setPassErr (err.message);
        return;
      }
      onLogout();
    });
  };

  return (
    <StyledContainer>
      <StyledBox>
        {stage >= 0 && (
          <TypingLine text="*** Registro OverPower.TV ***" onDone={() => setStage(1)} />
        )}

        {stage >= 1 && stage <= 7 && (
          <TypingLine text="Ingrese su nickname:" onDone={() => setStage(2)} />
        )}
        {stage >= 2 && (
          <StyledTextField
            fullWidth
            variant="standard"
            placeholder="nickname"
            value={givenName}
            onChange={(e) => setGivenName(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && setStage(3)}
            autoFocus
          />
        )}

        {stage >= 3 && (
          <TypingLine text="Ingrese su email:" onDone={() => setStage(4)} />
        )}
        {stage >= 4 && (
          <StyledTextField
            fullWidth
            variant="standard"
            placeholder="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && setStage(5)}
          />
        )}

        {stage >= 5 && (
          <TypingLine text="Ingrese y confirme su clave:" onDone={() => setStage(6)} />
        )}

        {stage === 6 && (
          <>
            <StyledTextField
              fullWidth
              variant="standard"
              type="password"
              placeholder="clave"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <StyledTextField
              fullWidth
              variant="standard"
              type="password"
              placeholder="confirmar clave"
              value={password2}
              onChange={(e) => setPassword2(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleRegister()}
            />
           
            <StyledButton fullWidth variant="outlined" onClick={handleRegister}>
              registrar
            </StyledButton>
          </>
        )}

        {stage >= 7 && (
          <TypingLine
            text="Registro exitoso. Por favor ingrese el código de verificación enviado a su email:"
            onDone={() => setStage(8)}
          />
        )}

        {stage >= 8 && (
          <>
            <StyledTextField
              fullWidth
              variant="standard"
              placeholder="código de verificación"
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleVerification()}
            />
            <StyledButton fullWidth variant="outlined" onClick={handleVerification}>
              verificar
            </StyledButton>
          </>
        )}
 <TypingLine text={passErr} isError = 'true'/>
        <Box mt={2}>
          <Link
            onClick={onLogout}
            sx={{ color: '#C77DFF', fontFamily: 'monospace', cursor: 'pointer' }}
          >
            volver al login
          </Link>
        </Box>
      </StyledBox>
    </StyledContainer>
  );
};

export default Registration;